import React from 'react';
import useStyles from './Styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Hidden from '@mui/material/Hidden';
import StoreImg from './StoreImg';
import {Tools} from './Tools';
import {Inc,Owner} from './Inc';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

interface Props {
    list: any[],
    owner: Owner,
    pager: any,
    jump(newPage:number):void,
    selectedTypeId: string,
}

const FavListItem = (props:Props)=> {
    const classes = useStyles();
	
	return (
		<div id="fav_list_search">

            <Table>
                <TableHead>
                    <TableRow>
                        <Hidden mdDown implementation="js">
                            <TableCell className={classes.tableHeadNowrap} align='center'>画像</TableCell>
                        </Hidden>
                        <TableCell className={classes.tableHeadNowrap} align='center'>商品名</TableCell>
                        <TableCell className={classes.tableHeadNowrap} align='center'>BOX</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
            {props.list.map( (sale:any,index:number)=>{
                const key = "sale"+index;
                return (
                    <TableRow key={key}>
                        <Hidden mdDown implementation="js">
                            <TableCell className={classes.tableCellDense} align='center' style={{width:'5em'}}><StoreImg owner_id={props.owner.owner_id} img_id={sale.img_id} thumb={true} className="imgList"/></TableCell>
                        </Hidden>
                        <TableCell className={classes.tableCellDense}>
                            <span className={classes.itemId}>ID:{sale.item_id}</span><br/>
                            {sale.item_name}<br/>
                        </TableCell>
                        <TableCell className={classes.tableCellNowrap} style={{textAlign:"center",verticalAlign:"top"}}>
                            {(props.selectedTypeId==="" || props.selectedTypeId==="1") &&
                            <div className={classes.favTypeList} style={{display:'flex', alignItems: 'center'}}>
                                <span className={classes.favIcon+" "+classes.favBackColor1}>
                                    <FontAwesomeIcon icon="heart"/>
                                    <span style={{marginLeft:"0.5em"}}>{Tools.getLabel(Inc.favTypes,"1")}</span>
                                </span>
                                <span className={classes.favTypeListCount+" "+classes.favColor1} style={{display:'block'}}>{Tools.comma(sale.list[0])}</span>
                            </div>
                            }
                            {(props.selectedTypeId==="" || props.selectedTypeId==="6") &&
                            <div className={classes.favTypeList}>
                                <span className={classes.favIcon+" "+classes.favBackColor6}>
                                    <FontAwesomeIcon icon="gift"/>
                                    <span style={{marginLeft:"0.5em"}}>{Tools.getLabel(Inc.favTypes,"6")}</span>
                                </span>
                                <span className={classes.favTypeListCount+" "+classes.favColor6}>{Tools.comma(sale.list[5])}</span>
                            </div>
                            }
                            {(props.selectedTypeId==="" || props.selectedTypeId==="3") &&
                            <div className={classes.favTypeList}>
                                <span className={classes.favIcon+" "+classes.favBackColor3}>
                                    <FontAwesomeIcon icon="lightbulb"/>
                                    <span style={{marginLeft:"0.5em"}}>{Tools.getLabel(Inc.favTypes,"3")}</span>
                                </span>
                                <span className={classes.favTypeListCount+" "+classes.favColor3}>{Tools.comma(sale.list[2])}</span>
                            </div>
                            }
                            {(props.selectedTypeId==="" || props.selectedTypeId==="4") &&
                            <div className={classes.favTypeList}>
                                <span className={classes.favIcon+" "+classes.favBackColor4}>
                                    <FontAwesomeIcon icon="seedling"/>
                                    <span style={{marginLeft:"0.5em"}}>{Tools.getLabel(Inc.favTypes,"4")}</span>
                                </span>
                                <span className={classes.favTypeListCount+" "+classes.favColor4}>{Tools.comma(sale.list[3])}</span>
                            </div>
                            }
                            {(props.selectedTypeId==="" || props.selectedTypeId==="5") &&
                            <div className={classes.favTypeList}>
                                <span className={classes.favIcon+" "+classes.favBackColor5}>
                                    <FontAwesomeIcon icon="gem"/>
                                    <span style={{marginLeft:"0.5em"}}>{Tools.getLabel(Inc.favTypes,"5")}</span>
                                </span>
                                <span className={classes.favTypeListCount+" "+classes.favColor5}>{Tools.comma(sale.list[4])}</span>
                            </div>
                            }
                            {(props.selectedTypeId==="" || props.selectedTypeId==="9") &&
                            <div className={classes.favTypeList}>
                                <span className={classes.favIcon+" "+classes.favBackColor9}>
                                    <FontAwesomeIcon icon="comment"/>
                                    <span style={{marginLeft:"0.5em"}}>{Tools.getLabel(Inc.favTypes,"9")}</span>
                                </span>
                                <span className={classes.favTypeListCount+" "+classes.favColor9}>{Tools.comma(sale.list[6])}</span>
                            </div>
                            }
                        </TableCell>
                    </TableRow>
                );
            })}
                </TableBody>
            </Table>
            <div style={{padding:"1em"}}>
            {Tools.pager(props.pager,props.jump)}
            </div>


		</div>
	);
}

export default FavListItem;
